module.exports = __webpack_public_path__ + "img/description-pdf.a70200cd.png";